import {IconSchool} from '@tabler/icons-react';
import type {CourseClassroomStateEnum} from 'src/api/ProactApiClient';
import {
  CourseSessionStateEnum,
  CourseSessionTypeEnum,
} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';
import {CourseClassroomStatePill} from 'src/shared/constants/PillConstants';
import {getLanguageDisplayName} from './languageUtils';

export const TrainingIcon = <IconSchool />;

export const CoursePillConfig = (status: boolean): PillProps[] => {
  switch (status) {
    case true:
      return [{text: 'Active', color: 'blue'}];
    case false:
      return [{text: 'Inactive', color: 'yellow'}];
    default:
      break;
  }
  return [];
};

export const CourseSessionPillConfig = (
  status?: CourseSessionStateEnum,
  type?: CourseSessionTypeEnum,
  language?: string | null
): PillProps[] => {
  const pills: PillProps[] = [];

  switch (status) {
    case undefined:
      pills.push({text: 'Not started', color: 'yellow'});
      break;
    case CourseSessionStateEnum.Pending:
      pills.push({text: 'In-progress', color: 'blue'});
      break;
    case CourseSessionStateEnum.Cancelled:
      pills.push({text: 'Cancelled', color: 'yellow'});
      break;
    case CourseSessionStateEnum.Completed:
      pills.push({text: 'Completed', color: 'green'});
      break;
    case CourseSessionStateEnum.Failed:
      pills.push({text: 'Failed', color: 'red'});
      break;
    case CourseSessionStateEnum.Expired:
      pills.push({text: 'Expired', color: 'red'});
      break;
    case CourseSessionStateEnum.Invalid:
    default:
      break;
  }

  switch (type) {
    case CourseSessionTypeEnum.AdministratorSignOff:
      pills.push({text: 'Admin Sign-Off', color: 'blue'});
      break;

    case undefined:
    case CourseSessionTypeEnum.Standard:
      break;
  }

  if (language) {
    pills.push({text: getLanguageDisplayName(language), color: 'gray'});
  }

  return pills;
};

export const CourseClassroomPillConfig = (
  status?: CourseClassroomStateEnum
): PillProps[] => {
  const pills: PillProps[] = [];

  if (status) {
    pills.push(CourseClassroomStatePill(status));
  }

  return pills;
};
